import {
  type ConfigurationSettingsResponse,
  useGetConfigurationSettings,
} from '@/api/REST/configuration-settings';

export const useUserAccountSettingValue = <
  K extends keyof ConfigurationSettingsResponse,
>(
  settingKey: K,
) => {
  const {
    data: configurationSettings,
    isLoading,
    ...restProps
  } = useGetConfigurationSettings();

  const settingValue = configurationSettings?.[settingKey];

  return {
    settingValue: settingValue as ConfigurationSettingsResponse[K],
    isLoading,
    ...restProps,
  };
};
